import React from "react";
import { Link, withRouter } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { Config } from "../../Config";
import Installment from "../../assets/images/Installment.svg";
import Guarantee from "../../assets/images/guarant.svg";
import Club from "../../assets/images/club.svg";
import StopWatch from "../../assets/images/stopWatch.svg";
import AddCart from "../../assets/images/addCart.svg";

const ProductItem = (props) => {
  return (
    <React.Fragment>
      {props.loading ? (
        props.productItemData.map((item, index) => {
          return (
            <div key={index} className="productItem">
              <div className="imageFigure">
                <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
              </div>
              <div className="productDetail">
                <Link to="" className="productTitle">
                  <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
                </Link>
                <p className="productAmount">
                  <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
                </p>
              </div>
            </div>
          );
        })
      ) : (
        <React.Fragment>
          {props.productItemData.map((item, index) => {
            return (
              <div className="wrapperHelp">
                <Link to={`/products/${item.id}/${item.name.replaceAll(" ", "-")}`} key={index} className="productItem">
                  <div className="imageFigure">
                    <span className="plink">
                      <img src={item.image} alt={item.name} className="productImage" />
                    </span>
                  </div>
                  <div className="itemGroups">
                    {item.isInstallments && (
                      <div className="itemGroupFigure">
                        <img src={Installment} className="figureImage" alt="Installment" />
                      </div>
                    )}
                    {item.hasGuruanty && (
                      <div className="itemGroupFigure">
                        <img src={Guarantee} className="figureImage" alt="Guarantee" />
                      </div>
                    )}
                    {item.point > 0 && (
                      <div className="itemGroupFigure">
                        <img src={Club} className="figureImage" alt="club" />
                      </div>
                    )}
                  </div>
                  <div className="productDetail">
                    <span className="productTitle">{item.name}</span>
                  </div>
                  <div className="priceBox">
                    <div className="item2">
                      <div className="exist">
                        {item.count > 0 ? (
                          <>
                            <span className="green"></span> موجود
                          </>
                        ) : (
                          <>
                            <span className="red"></span> ناموجود
                          </>
                        )}
                      </div>
                      <p className="amount">{Config.separate(item.price)} ریال</p>
                    </div>
                  </div>
                  <div className="addCart">
                    <img src={AddCart} alt="add to cart" />
                    <span>افزودن به سبد خرید</span>
                  </div>
                </Link>
              </div>
            );
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default React.memo(withRouter(ProductItem));
